import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { reduxForm } from 'redux-form';
import moment from 'moment';

import { DictFilter, SourceFilter, DateSelect, Container, Input, DoubleField, DateTime, ButtonsContainer } from 'libs/form';
import { ResetBtn, UseBtn } from 'libs/ui';

const initialValues = {
  time_from: moment().startOf('day').format(),
  time_to: moment().endOf('day').format(),
};

const Filter = ({ handleSubmit, reset, change, setInitial, parkingId }) => {
  const { t } = useTranslation();

  useEffect(() => {
    setInitial(initialValues);
  }, [setInitial]);

  return (
    <Container>
      <form onSubmit={handleSubmit}>
        <DateSelect from_name="time_from" to_name="time_to" change={change}>
          <DoubleField>
            <DateTime width="160px" name="time_from" type="dateTime" label={t('filter.Начало события')} />
            <DateTime width="160px" name="time_to" type="dateTime" />
          </DoubleField>
        </DateSelect>

        <DictFilter w={130} dict="calls.type" />

        <DictFilter w={110} dict="calls.status" multiple />

        <DoubleField>
          <Input width="110px" name="dur_from" type="text" label={t('filter.Длительность')} mask="99ч 99м 99с" storeWithMask placeholder={t('filter.От')} />
          <Input width="110px" name="dur_to" type="text" mask="99ч 99м 99с" storeWithMask placeholder={t('filter.До')} />
        </DoubleField>

        <SourceFilter multiple exclude={['rack.server', 'rack.cashbox']} parkingId={parkingId} />

        <ButtonsContainer>
          <ResetBtn onClick={reset} />
          <UseBtn />
        </ButtonsContainer>
      </form>
    </Container>
  );
};

export default reduxForm({
  form: 'callsFilter',
  // destroyOnUnmount: false,
  initialValues: initialValues,
})(Filter);
